import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suggestion-alerts',
  templateUrl: './suggestion-alerts.component.html',
  styleUrls: ['./suggestion-alerts.component.scss']
})
export class SuggestionAlertsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
